import { useEffect, useRef } from "react";
import { useSnackbar } from 'notistack';
import { Button } from "@mui/material";

const STORAGE_KEY = "notification-prompt-dismissed";

function EnableNotificationsDialog() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const shown = useRef(false);

  useEffect(() => {
    if (shown.current) return;

    const dismissed = localStorage.getItem(STORAGE_KEY);

    if (
      !dismissed &&
      ("Notification" in window) &&
      Notification.permission === "default"
    ) {
      shown.current = true;

      enqueueSnackbar(
        "Enable browser notifications to stay updated with messages and alerts.",
        {
          variant: "info",
          autoHideDuration: 8000,
          action: (snackbarId) => (
            <>
              <Button
                size="small"
                variant="contained"
                sx={{ mr: 0.5, color: 'common.white' }}
                onClick={async () => {
                  if ("Notification" in window) {
                    await Notification.requestPermission();
                  }
                  localStorage.setItem(STORAGE_KEY, "true");
                  closeSnackbar(snackbarId);
                }}
              >
                Enable
              </Button>
              <Button
                size="small"
                sx={{ color: 'common.white' }}
                onClick={() => {
                  localStorage.setItem(STORAGE_KEY, "true");
                  closeSnackbar(snackbarId);
                }}
              >
                Dismiss
              </Button>
            </>
          ),
          onClose: () => {
            localStorage.setItem(STORAGE_KEY, "true");
          },
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export default EnableNotificationsDialog;
